import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { TravelTwoIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getAffectedStaffs } from '../../api/affected-staffs/get-affected-staffs'
import LoadingScreen from '../../components/elements/loading/loading-screen'
import UserNavBar from '../../components/elements/nav-bar'
import JourneyInformationCard from '../../components/pages/staff-personal-space/my-journeys/journey-information-card'
import { Paths } from '../../lib/constants/path'
import { useObserver } from '../../lib/contexts/observer'
import useAuth from '../../lib/hooks/use-auth'
import useTranslate from '../../lib/hooks/use-translate'
import { AffectedStaffStatusEnum } from '../../lib/types/enums/affected-staff/affected-staff-status.enum'

const StaffPersonalSpaceMyJourneysPage = () => {
  const { t } = useTranslate()
  const { user } = useAuth()
  const { navigate } = useNavigator()
  const observer = useObserver({ key: 'click-affected-staff-card' })

  const staffId = user?.staff?.id

  const { data: affectedStaffData, isPending } = useQuery({
    queryKey: ['affectedStaffs', staffId, { hasCenters: true }],
    queryFn: () => {
      if (!staffId) throw new Error('Staff ID is required')
      return getAffectedStaffs(
        { filter: { staffId, hasCenters: true, statuses: [AffectedStaffStatusEnum.AFFECTED] } },
        'VIEW'
      )
    },
    enabled: !!staffId
  })

  if (isPending) return <LoadingScreen />

  return (
    <div className="flex flex-col gap-5 ">
      <UserNavBar title={t('staff.personal.space.my.journeys.title')} icon={TravelTwoIcon} />
      <Box className="rounded-2xl p-5 flex flex-col gap-2">
        <Typography variant="h6" color={tailwindColors.grey.DEFAULT}>
          {t('staff.personal.space.my.journeys.subtitle')}
        </Typography>
        <Typography variant="body" color={tailwindColors.grey.lighter}>
          {t('staff.personal.space.my.journeys.information')}
        </Typography>
        <div className="h-1 mobile:h-4" />
        <div className="grid grid-cols-2 gap-3 mobile:grid-cols-1">
          {affectedStaffData?.data?.map((affectedStaff) => (
            <JourneyInformationCard
              key={affectedStaff.id}
              affectedStaff={affectedStaff}
              onLinkClick={() => {
                observer.notify(['update-navbar-affected-staffs'], { id: affectedStaff.id })
                navigate(
                  Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS.replace(
                    ':id',
                    affectedStaff.id.toString()
                  ).replace('*', Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_HOME)
                )
              }}
            />
          ))}
        </div>
      </Box>
    </div>
  )
}

export default StaffPersonalSpaceMyJourneysPage
